import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import BenefitsSection from './components/BenefitsSection';
import SolutionsSection from './components/SolutionsSection';
import FormSection from './components/FormSection';
import NotFound from './components/NotFound';
import './App.css';

// Home component for the main page
const HomePage = () => (
  <>
    <Header />
    <main>
      <HeroSection />
      <BenefitsSection />
      <SolutionsSection />
      <FormSection />
    </main>
  </>
);

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        
        <footer className="footer">
          <div className="container">
            <div className="footer__content">
              <div className="footer__brand">
                <div className="footer__logo">
                  <img 
                    src="/images/horizontalbranco.png" 
                    alt="Nukard - Soluções Digitais" 
                    className="footer__logo-img"
                    loading="lazy"
                  />
                </div>
                <p className="footer__description">
                  Soluções digitais acessíveis, rápidas e personalizadas 
                  para pequenos negócios e profissionais autônomos.
                </p>
              </div>
            
            <div className="footer__links">
              <div className="footer__column footer__column--solutions">
                <h4 className="footer__title">Soluções</h4>
                <ul className="footer__list">
                  <li><a href="#solutions">Sites Profissionais</a></li>
                  <li><a href="#solutions">Apps de Agendamento</a></li>
                  <li><a href="#solutions">Automações</a></li>
                  <li><a href="#solutions">Projetos Personalizados</a></li>
                </ul>
              </div>
              
              <div className="footer__column footer__column--company">
                <h4 className="footer__title">Empresa</h4>
                <ul className="footer__list">
                  <li><a href="#benefits">Nossos Benefícios</a></li>
                  <li><a href="#form-section">Solicitar Orçamento</a></li>
                  <li><a href="mailto:contato@nukard.com">Contato</a></li>
                  <li><a href="https://wa.me/5541995253523" target="_blank" rel="noopener noreferrer">WhatsApp</a></li>
                </ul>
              </div>
              
              <div className="footer__column footer__column--contact">
                <h4 className="footer__title">Contato</h4>
                <ul className="footer__list">
                  <li>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="currentColor" strokeWidth="2"/>
                      <path d="M22 6L12 13L2 6" stroke="currentColor" strokeWidth="2"/>
                    </svg>
                    contato@nukard.com
                  </li>
                  <li>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M22 16.92V19C22 20.1 21.1 21 20 21C10.6 21 3 13.4 3 4C3 2.9 3.9 2 5 2H7.08C7.21 2 7.32 2.08 7.36 2.21L8.82 6.53C8.86 6.66 8.82 6.8 8.72 6.88L6.93 8.68C8.15 11.25 10.75 13.85 13.32 15.07L15.12 13.28C15.2 13.18 15.34 13.14 15.47 13.18L19.79 14.64C19.92 14.68 20 14.79 20 14.92V16.92H22Z" stroke="currentColor" strokeWidth="2"/>
                    </svg>
                    (41) 99525-3523
                  </li>
                  <li>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M21 10C21 17 12 23 12 23S3 17 3 10C3 5.03 7.03 1 12 1S21 5.03 21 10Z" stroke="currentColor" strokeWidth="2"/>
                      <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2"/>
                    </svg>
                    Curitiba, PR
                  </li>
                </ul>
              </div>
            </div>
          </div>
          
          <div className="footer__bottom">
            <p className="footer__copyright">
              © {new Date().getFullYear()} Nukard. Todos os direitos reservados.
            </p>
            <div className="footer__social">
              <a href="https://instagram.com/nukard" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" stroke="currentColor" strokeWidth="2"/>
                  <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z" stroke="currentColor" strokeWidth="2"/>
                  <path d="M17.5 6.5h.01" stroke="currentColor" strokeWidth="2"/>
                </svg>
              </a>
              <a href="https://linkedin.com/company/nukard" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M16 8A6 6 0 016 8v7H4V8a8 8 0 0116 0v7h-2V8z" stroke="currentColor" strokeWidth="2"/>
                  <rect x="2" y="9" width="4" height="12" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="4" cy="4" r="2" stroke="currentColor" strokeWidth="2"/>
                </svg>
              </a>
              <a href="https://wa.me/5541995253523" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M21 11.5A8.38 8.38 0 0112.5 3h-.5A8.48 8.48 0 003 11.5c0 2.81 1.41 5.41 3.71 7.21L3 22l3.29-3.71A8.38 8.38 0 0011.5 21h.5A8.48 8.48 0 0021 11.5z" stroke="currentColor" strokeWidth="2"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
        </footer>
      </div>
    </Router>
  );
}

export default App; 
